import React, { useState, useCallback } from 'react';
import { Button, TextField, Select, MenuItem, InputLabel, FormControl, Box } from '@mui/material';
import './Filter.css';

const Filter = ({ onFilterChange }) => {
  const [status, setStatus] = useState('');
  const [likes, setLikes] = useState('');
  const [nameOrId, setNameOrId] = useState('');
  const [registrationDate, setRegistrationDate] = useState('');

  const handleClear = useCallback(() => {
    setStatus('');
    setLikes('');
    setNameOrId('');
    setRegistrationDate('');
    onFilterChange({ status: '', likes: '', nameOrId: '', registrationDate: '' });
  }, [onFilterChange]);

  const handleApply = useCallback(() => {
    onFilterChange({ status, likes, nameOrId, registrationDate });
  }, [status, likes, nameOrId, registrationDate, onFilterChange]);

  const handleUpdate = useCallback(() => {
  }, []);

  return (
    <div className="user-list-container">
      <form className="user-form">  
        <FormControl variant="filled" className="text-input" fullWidth>
          <InputLabel id="status-label">Статус</InputLabel>
          <Select labelId="status-label" value={status} onChange={(e) => setStatus(e.target.value)}>
            <MenuItem value="">Не выбрано</MenuItem>
            <MenuItem value="active">Активен</MenuItem>
            <MenuItem value="inactive">Деактивирован</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="filled" className="text-input" fullWidth>
          <InputLabel id="likes-label">Лайки</InputLabel>
          <Select labelId="likes-label" value={likes} onChange={(e) => setLikes(e.target.value)}>
            <MenuItem value="">Не выбрано</MenuItem>
            <MenuItem value="0">Нет</MenuItem>
            <MenuItem value=">1">Да</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Номер/ФИО"
          variant="filled"
          fullWidth
          className="text-input"
          value={nameOrId}
          onChange={(e) => setNameOrId(e.target.value)}
          InputProps={{ className: "text-field" }}
        />
        <TextField
          label="Дата регистрации"
          type="date"
          variant="filled"
          fullWidth
          className="date-input"
          value={registrationDate}
          onChange={(e) => setRegistrationDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          InputProps={{ className: "text-field" }}
        />
        <Box className="action-buttons">
          <Button variant="contained" color="primary" onClick={handleApply}>
            Применить
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleClear}>
            Очистить
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleUpdate}>
            Обновить
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default Filter;